<script setup>
import {onMounted, ref, reactive} from "vue";
import YTTablePagination from "@/components/YTTablePagination/YTTablePagination.vue";
import router from "@/router/index.js";
import moment from "moment";
import YTAddress from "@/components/YTAddress/index.vue";
import YTFormDialog from "@/components/YTFormDialog/index.vue";
import {listTenantOrganizeIgnore, listTenantOrganizeNotStoreIdIgnore} from "@/api/tenant/tenant.js";
import {getStoreCooperation, uploadStoreCooperation} from "@/api/storeCooperation/storeCooperation.js";
import YTPartnerSelectPanel from "@/views/tenant/components/YTPartnerSelectPanel/index.vue";

/*初次加载*/
onMounted(async () => {
  await handleSearch()
})

/*搜索功能*/
// 表单数据
const formData = reactive({
  keyword: null,
  provinceCode: null,
  cityCode: null,
  districtCode: null,
  time: [],
  type: "BIKE_STORE",
  address: null
});
// 表单锚点
const ruleFormRef = ref()
// 根据表单搜索信息
const handleSearch = async (mode = "init") => {
  if (mode === 'btnSearch') YTTablePaginationRef.value.resetPage()
  try {
    const page = {
      page: YTTablePaginationRef.value.getPage(),
      pageSize: YTTablePaginationRef.value.getPageSize()
    }
    loading.value = true
    let param = {
      type: formData.type,
      keyword: formData.keyword,
      provinceCode: formData.provinceCode,
      cityCode: formData.cityCode,
      districtCode: formData.districtCode,
      startApplyTime: formData.time.length > 0 ? moment(formData.time[0]).format("YYYY-MM-DD HH:mm:ss") : null,
      endApplyTime: formData.time.length > 0 ? moment(formData.time[1]).add(23, "h").add(59, "m").add(59, "s").format("YYYY-MM-DD HH:mm:ss") : null,
    }
    const res = await listTenantOrganizeIgnore(page, param);
    tableData.value = []
    tableData.value = res.list
    total.value = parseInt(res.total)
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 清空表单内容
const handleReset = () => {
  formData.keyword = null
  formData.provinceCode = null
  formData.cityCode = null
  formData.districtCode = null
  formData.time = []
  formData.address = null
  handleSearch('btnSearch')
}
// 新建商家车店
const handleAdd = () => {
  router.push("/addTenantBikeStore")
}
// 处理选择所属区域
const handleSelectAddress = (data) => {
  console.log("data:", data)
  formData.address = data.value
  formData.provinceCode = data.value[0]
  formData.cityCode = data.value[1]
  formData.districtCode = data.value[2] ? data.value[2] : null
}

/*表格数据展示*/
// 翻页组件锚点
const YTTablePaginationRef = ref()
// 翻页信息：总条目数、加载状态
const total = ref(0)
const loading = ref(false)
const headers = ref([
  { title: '车店名称', key: 'name', nowrap: true },
  { title: '所在位置', key: 'storeAddress', nowrap: true },
  { title: '负责人', key: 'contactName', nowrap: true },
  { title: '联系电话', key: 'phone', nowrap: true },
  { title: '进驻日期', key: 'crTime', nowrap: true },
  { title: '商家名称', key: 'tenantName', nowrap: true },
  { title: '协助运营', key: 'assistsOperation', nowrap: true },
  { title: '关联状态', key: 'bikeStoreId', nowrap: true },
  { title: '状态', key: 'state', nowrap: true },
  { title: '操作', key: 'controls', width: "120px", fixed: true },
])
// 表格数据
const tableData = ref([])
// 翻页
const handleChangePage = () => {
  handleSearch()
}

/*操作栏相关*/
// 处理关联合作身份
const handleCorrelation = async (item) => {
  console.log("item", item)
  cacheTenantId.value = item.tenantId
  cacheTenantName.value = item.tenantName
  cacheStoreId.value = item.storeId
  try {
    cachePartnerStores.value = await getStoreCooperation(cacheStoreId.value)
    handleOpenPanel()
  } catch (e) {
    console.log(e)
  }
}
// 处理查看详情
const handleEdit = (item) => {
  router.push({path: "/editTenantBikeStore", query: {storeId: item.storeId}})
}

/*合作身份列表相关*/
// 合作身份列表
const partnerList = ref([])
// 合作身份列表加载状态
const partnerLoading = ref(false)
// 查询合作身份的商家id
const cacheTenantId = ref()
// 合作身份的商家名称
const cacheTenantName = ref()
// 获取合作身份列表
const handleGetPartnerList = async () => {
  partnerLoading.value = true
  let page = {
    page: 1,
    pageSize: 100,
  }
  let param = {
    tenantId: cacheTenantId.value,
    storeId: cacheStoreId.value
  }
  const res = await listTenantOrganizeNotStoreIdIgnore(page, param)
  partnerList.value = res.list
  console.log(res)
  partnerLoading.value = false
}

/*合作身份面板弹窗相关*/
// 面板锚点
const YTPartnerSelectPanelRef = ref()
// 处理面板打开
const handleOpenPanel = async () => {
  if (!cacheTenantId.value) return ElMessage.error("请先选择所属商家")
  YTPartnerSelectPanelRef.value.handleOpen()
  await handleGetPartnerList()
}
// 处理面板确认
const handlePanelConfirm = async (stores) => {
  try {
    loading.value = true
    console.log("stores", stores)
    cachePartnerStores.value = stores
    let temp = stores.map(store => (store.storeId))
    console.log("cacheStoreId.value", cacheStoreId.value)
    let param = {
      storeId: cacheStoreId.value,
      partnerStoreIds: temp
    }
    console.log("param", param)
    await uploadStoreCooperation(param)
    ElMessage.success("修改成功")
    loading.value = false
  } catch (e) {
    console.log(e)
    loading.value = false
  }
}
// 处理面板关闭
const handlePanelClose = () => {
  cacheTenantId.value = null
  cacheTenantName.value = null
  cachePartnerStores.value = []
  cacheStoreId.value = null
}
// 合作身份已选缓存
const cachePartnerStores = ref([])
// 店铺ID缓存
const cacheStoreId = ref()

</script>

<template>
  <div class="container_box mg_b_2" style="padding-bottom: 16px">
    <div class="flex_left" style="padding-left: 16px;">
      <v-btn color="success" @click="handleAdd">
        <template v-slot:default>
          <div class="flex_bt">
            <img
                style="width: 14px; height: 14px; margin-right: 4px"
                src="https://yttec-bucket.oss-cn-guangzhou.aliyuncs.com/resources/newUi/filter/filter/plus.svg"
            />
            <span>新建车店</span>
          </div>
        </template>
      </v-btn>
    </div>
  </div>
  <div class="container_box mg_b_2" style="padding-bottom: 0">
    <el-form
        ref="ruleFormRef"
        style="width: 100%;text-align: left"
        :model="formData"
        label-width="auto"
        class="demo-ruleForm"
        status-icon
        label-position="top"
    >
      <div class="flex_left flex_warp">
        <el-form-item label="关键词：" prop="keyword">
          <el-input class="mg_r_2" style="width: 300px;" v-model="formData.keyword" placeholder="关键词搜索"></el-input>
        </el-form-item>
        <el-form-item label="所在地区：" prop="address">
          <div class="mg_r_2" style="width: 300px">
            <YTAddress ref="YTAddressRef" :title="'所在地区'" :address-code="formData.address" @select="handleSelectAddress"></YTAddress>
          </div>
        </el-form-item>
        <el-form-item label="进驻时间：" prop="time">
          <el-date-picker
              v-model="formData.time"
              type="daterange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
          />
        </el-form-item>
      </div>
    </el-form>
    <v-col cols="3">
      <v-row justify="start">
        <v-col class="flex_left" cols="6">
          <v-btn color="success" size="large" @click="handleSearch('btnSearch')">搜索</v-btn>
        </v-col>
        <v-col class="flex_left" cols="6">
          <v-btn size="large" @click="handleReset">重置</v-btn>
        </v-col>
      </v-row>
    </v-col>
  </div>
  <div class="container_box">
    <v-row justify="center">
      <v-col cols="12">
        <v-data-table
            :headers="headers"
            :items="tableData"
            :loading="loading"
            :items-per-page="$globalPageSize"
            :no-data-text="'没有更多数据了~'"
            hover
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table-row@1"></v-skeleton-loader>
          </template>

          <template v-slot:item.storeAddress="{ item }">
            {{item.storeAddress.province}}{{item.storeAddress.city}}{{item.storeAddress.district}}{{item.storeAddress.addressDetail}}
          </template>

          <template v-slot:item.contactName="{ item }">
            <div v-if="item.contactName">
              {{item.contactName}}
            </div>
            <div v-else>
              -
            </div>
          </template>

          <template v-slot:item.bikeStoreId="{item}">
            {{item.bikeStoreId ? "是" : "否"}}
          </template>

          <template v-slot:item.assistsOperation="{item}">
            {{item.assistsOperation ? "是" : "否"}}
          </template>

          <template v-slot:item.state="{item}">
            <div v-if="item.state === 'VALID'">正常</div>
            <div v-else-if="item.state === 'LOGOUT'">注销</div>
            <div v-else>-</div>
          </template>

          <template v-slot:item.controls="{ item }">
            <div class="flex_left">
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="详情"
                  placement="left">
                <v-icon class="cursor-pointer mg_r_1" icon="mdi-list-box-outline" color="warning" @click="handleEdit(item)"></v-icon>
              </el-tooltip>
              <el-tooltip
                  class="box-item"
                  effect="dark"
                  content="关联合作身份"
                  placement="top">
                <v-icon icon="mdi-link-variant" color="primary" size="small" @click="handleCorrelation(item)"></v-icon>
              </el-tooltip>
            </div>
          </template>

          <template v-slot:bottom>
            <YTTablePagination ref="YTTablePaginationRef" :total="total" @page-change="handleChangePage"></YTTablePagination>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
  <YTPartnerSelectPanel :tenant-name="cacheTenantName" :loading="partnerLoading" ref="YTPartnerSelectPanelRef" :selectedStores="cachePartnerStores" :tableData="partnerList" @confirm="handlePanelConfirm" @close="handlePanelClose"></YTPartnerSelectPanel>
</template>

<style scoped>
::marker {
  content: none;
}
</style>
